import { Injectable } from '@angular/core';
import { AgoraRecorderService } from './agora-recorder.service';
import { AntmediaRecorderService } from './antmedia-recorder.service';
import { AudioControlService, AudioProviders } from './audio-control-service';
import { RecordingService } from './recording-service.interface';

@Injectable({
  providedIn: 'root',
})
export class RecorderFactoryService {
  private cached: RecordingService;

  constructor(private audioService: AudioControlService) {}

  async getActiveRecorder(auctionId: string, fromCache = false): Promise<RecorderEntry> {
    return new Promise((res, rej) => {
      if (fromCache && this.cached) {
        res({ cached: true, recorder: this.cached });
        return;
      }

      this.audioService.getAudioConfig(auctionId).subscribe(
        (config) => {
          switch (config.providerName) {
            case AudioProviders.Agora:
              this.cached = new AgoraRecorderService(config);
              res({ cached: false, recorder: this.cached });
              break;
            case AudioProviders.AntMedia:
              this.cached = new AntmediaRecorderService(config);
              res({ cached: false, recorder: this.cached });
            default:
              rej('Audio provider not supported');
              break;
          }
        },
        (error) => rej(error),
      );
    });
  }
}

export interface RecorderEntry {
  cached: boolean;
  recorder: RecordingService;
}
